export default function DiscordIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Vector"
          d="M16.1292 4.53485C14.9786 4.02082 13.7589 3.64235 12.4816 3.43335C12.3205 3.70449 12.1422 4.07165 12.0156 4.35974C10.6578 4.16768 9.31155 4.16768 7.97678 4.35974C7.8502 4.07165 7.6661 3.70449 7.51076 3.43335C6.22777 3.64235 5.00231 4.02082 3.86315 4.53485C1.55607 7.87889 0.934711 11.1438 1.24539 14.3693C2.78153 15.4651 4.26013 16.1317 5.71572 16.5666C6.07243 16.0921 6.39461 15.5837 6.67077 15.0528C6.14722 14.8607 5.64668 14.6235 5.1634 14.341C5.28998 14.2563 5.4108 14.1546 5.53162 14.0586C8.43704 15.3634 11.5899 15.3634 14.4608 14.0586C14.5873 14.1546 14.7024 14.2506 14.829 14.341C14.3457 14.6235 13.8509 14.8551 13.3216 15.0528C13.5978 15.5894 13.92 16.0921 14.2767 16.5666C15.7323 16.1317 17.2166 15.4651 18.747 14.3693C19.1325 10.6411 18.1371 7.39875 16.1407 4.53485H16.1292ZM7.06775 12.3809C6.19325 12.3809 5.47984 11.6014 5.47984 10.6468C5.47984 9.69213 6.17599 8.9126 7.06775 8.9126C7.95952 8.9126 8.67293 9.69213 8.65567 10.6468C8.65567 11.6014 7.95376 12.3809 7.06775 12.3809ZM12.9304 12.3809C12.0559 12.3809 11.3425 11.6014 11.3425 10.6468C11.3425 9.69213 12.0386 8.9126 12.9304 8.9126C13.8222 8.9126 14.5356 9.69213 14.5183 10.6468C14.5183 11.6014 13.8222 12.3809 12.9304 12.3809Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
